import { useQuery } from '@tanstack/react-query';

import { queries } from '../../common/api/queryKeys/queries';

export const useRfqSupplierOnboarding = (requestForQuoteId: string) => {
    return useQuery({
        ...queries.supplierOnboarding.byRequestForQuoteId(requestForQuoteId),
        enabled: Boolean(requestForQuoteId),
    });
};
